import type { ReactNode } from 'react';
import { AuthProvider } from '@core/auth/context/AuthProvider';
import { ToastProvider } from '@shared/context/ToastContext';
import { CartProvider } from '@shared/context/CartContext';
import { ConfirmDialogProvider } from '@shared/context/ConfirmDialogContext';
import { WhatsAppProvider } from '@shared/context/WhatsAppContext';
import { ToastContainer } from '@shared/components/ui/ToastContainer';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ToastProvider>
      <ConfirmDialogProvider>
        <AuthProvider>
          <CartProvider>
            <WhatsAppProvider>{children}</WhatsAppProvider>
          </CartProvider>
        </AuthProvider>
      </ConfirmDialogProvider>
      <ToastContainer />
    </ToastProvider>
  );
}
